import React from "react";
import {
  Link
} from "react-router-dom";

const Navbar = ({scrollToCareer }) => {
  return (
      <nav className="bg-white shadow-md sticky top-0 z-10">
        <div className="navbar max-w-7xl mx-auto">
          <div className="navbar-start">
            {/* ======Logo===== */}
            <Link to="/" className="text-xl font-black uppercase flex items-center gap-2">
              <img className="w-10" src="image/icon/logo.png" alt="Insurance Cart Logo" />
              Insurance <span className="text-blue">Cart</span>
            </Link>
          </div>
          {/* ======Nav Links===== */}
          <div className="navbar-center hidden lg:flex">
            <ul className="flex gap-6 px-1">
              <li className="border-b-2 mt-1 font-medium border-white hover:border-blue duration-500 text-lg">
                <Link to="/">Home</Link>
              </li>
              <li className="border-b-2 mt-1 font-medium border-white hover:border-blue duration-500 text-lg dropdown">
                <p className="cursor-pointer">Insurance</p>
                <ul className="dropdown-menu">
                  <li><Link to="/health-insurance">Health Insurance</Link></li>
                  <li><Link to="/travel-insurance">Travel Insurance</Link></li>
                  <li><Link to="/business-insurance">Business Insurance</Link></li>
                  <li><Link to="/cheap-car-automobile-quotes">Car Insurance</Link></li>
                  <li><Link to="/house-insurance">House Insurance</Link></li>
                  <li><Link to="/compare-life-insurance">Life Insurance</Link></li>
                </ul>
              </li>
              <li className="border-b-2 mt-1 font-medium border-white hover:border-blue duration-500 text-lg">
                <Link to="/contact">Contact us</Link>
              </li>
              <li className="border-b-2 mt-1 font-medium border-white hover:border-blue duration-500 text-lg cursor-pointer">
                <Link onClick={scrollToCareer}>Career</Link>
              </li>
            </ul>
          </div>
          <div className="navbar-end">
            <Link to="/" className="text-blue border-2 border-blue px-6 py-1.5 rounded-full font-bold">
              Sign in
            </Link>
          </div>
        </div>
      </nav>
  );
};

export default Navbar;
